import React from 'react';
import {connect} from "react-redux";
import {
  CABINET_BATHROOM_LABELS,
  SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS,
} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import SqftOptionsRelatedItemList from "./commonParts/SqftOptionsRelatedItemList";
//import SqftWizardNavItemsList from "./commonParts/SqftWizardNavItemsList";
import SQFTFeaturesHeader from "./commonParts/SQFTFeaturesHeader";
import {FormattedMessage} from "react-intl";
import {addCabinetShapeToWorkspace} from "./helpers/addCabinetShapeToWorkspace";

const SqftNavigationBathroomCabinets = (props) => {
  const {activeFeature} = props;
  const {menuOpened} = props;
  const bathroomCabinetMenu = {
    [SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS.vanity]: {
      parentPartId: CABINET_BATHROOM_LABELS.vanity_cabinet,
      boxesPartId: CABINET_BATHROOM_LABELS.vanity_cabinet_boxes,
      titleId: "sqft.navigation.submenu.vanity",
    },
    [CABINET_BATHROOM_LABELS.vanity_cabinet_boxes]: {
      parentPartId: CABINET_BATHROOM_LABELS.vanity_cabinet,
      boxesPartId: CABINET_BATHROOM_LABELS.vanity_cabinet_boxes,
      titleId: "sqft.navigation.submenu.vanity",
    },
    [CABINET_BATHROOM_LABELS.vanitie_cabinet_boxes]: {
      parentPartId: CABINET_BATHROOM_LABELS.vanity_cabinet,
      boxesPartId: CABINET_BATHROOM_LABELS.vanitie_cabinet_boxes,
      titleId: "sqft.navigation.submenu.vanity",
    },
    [CABINET_BATHROOM_LABELS.top_cabinet_boxes]: {
      parentPartId: "top_cabinet",
      boxesPartId: CABINET_BATHROOM_LABELS.top_cabinet_boxes,
      titleId: "sqft.navigation.submenu.upperTitle",
    },
    [CABINET_BATHROOM_LABELS.wall_cabinet_boxes]: {
      parentPartId: CABINET_BATHROOM_LABELS.wall_vanity_cabinet,
      boxesPartId: CABINET_BATHROOM_LABELS.wall_cabinet_boxes,
      titleId: "sqft.navigation.submenu.upperTitle",
    },
    [CABINET_BATHROOM_LABELS.linen_cabinet_boxes]: {
      parentPartId: "linen_vanity_cabinet",
      boxesPartId: CABINET_BATHROOM_LABELS.linen_cabinet_boxes,
      titleId: "sqft.navigation.submenu.linen_cabinet_boxes",
      defaultTitle: "Linen Cabinet Boxes",
    },
  };
  const activeMenu = bathroomCabinetMenu[menuOpened];
  const expanded = !!activeMenu;

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")}>
      <div className="side-level2__inner ">
        <SQFTFeaturesHeader
          headerTitle={
            <FormattedMessage
              id={activeMenu?.titleId || "sqft.navigation.submenu.vanity"}
              defaultMessage={activeMenu?.defaultTitle}
            />
          }
          partId={activeMenu?.boxesPartId || CABINET_BATHROOM_LABELS.vanity_cabinet_boxes}
        />
        {expanded ?
          <>
            <SqftOptionsRelatedItemList activeFeature={activeFeature}
                                       partId={activeMenu.parentPartId}
                                       shouldSortByWidth={true}
                                       itemClickCallback={(feature, parentFeature) => {
                                         addCabinetShapeToWorkspace(feature, parentFeature)}
                                       }
            />
            {/*<SqftWizardNavItemsList activeFeature={activeFeature}*/}
            {/*                        partIds={[*/}
            {/*                          CABINET_BATHROOM_LABELS.vanity_cabinet_boxes,*/}
            {/*                          CABINET_BATHROOM_LABELS.vanitie_cabinet_boxes,*/}
            {/*                        ]}*/}
            {/*                        parentPartId={CABINET_BATHROOM_LABELS.vanity_cabinet}*/}
            {/*                        expanded={expanded}*/}
            {/*                        shouldSortByWidth={true}*/}
            {/*                        itemClickCallback={(feature, parentFeature) => {*/}
            {/*                          cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}*/}
            {/*                        }*/}
            {/*/>*/}
          </>
        : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {sqftFromFeature} = store.sqftState;
  return {
    menuOpened,
    activeFeature: sqftFromFeature ? sqftFromFeature.cartFeature : null
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationBathroomCabinets);
